<script setup lang="ts"></script>

<template>
  <icon name="lucide:x" />
</template>

<style scoped></style>
